export const DEFAULT_REDIRECT_PAGE = "/pages/layout/list-users";
export const LOGIN_PAGE = "/auth/login";
